import { defineStore } from 'pinia';
import { Motif } from '@/app/shared/enums/motif-enum';
import { ref } from 'vue';
import { PopupModalEvent } from '../enums/popup-events.enum';

export const useAlertStore = defineStore('alertStore', () => {
  const isAlertOpen = ref(false);
  const message = ref('');
  const title = ref('');
  const motif = ref<Motif>(Motif.WARN);

  const isPopupOpen = ref(false);
  const popupTitle = ref('');
  const popupMessage = ref('');
  const popupButtonEvent = ref<PopupModalEvent>(PopupModalEvent.OTHER_EVENT);

  const changeAlertVisibility = () => {
    isAlertOpen.value = !isAlertOpen.value;
  };

  const showNotification = (msg: string, title1: string, motif1: Motif) => {
    message.value = msg;
    title.value = title1;
    motif.value = motif1;
    if (!isAlertOpen.value) {
      changeAlertVisibility();
    }
    setTimeout(() => hideNotification(), 5000);
  };

  const hideNotification = () => {
    if (isAlertOpen.value) {
      changeAlertVisibility();
    }
  };

  const changePopupVisibility = () => {
    isPopupOpen.value = !isPopupOpen.value;
  };

  const showPopupModal = (title: string, msg: string) => {
    popupButtonEvent.value = PopupModalEvent.OTHER_EVENT;
    popupTitle.value = title;
    popupMessage.value = msg;
    if (!isPopupOpen.value) {
      changePopupVisibility();
    }
  };

  const handleCancel = () => {
    popupButtonEvent.value = PopupModalEvent.CLOSE_BUTTON_EVENT;
  };

  const handleConfirm = () => {
    popupButtonEvent.value = PopupModalEvent.OK_BUTTON_EVENT;
  };

  return {
    isAlertOpen,
    message,
    title,
    motif,
    isPopupOpen,
    popupMessage,
    popupTitle,
    changeAlertVisibility,
    showNotification,
    hideNotification,
    changePopupVisibility,
    showPopupModal,
    popupButtonEvent,
    handleCancel,
    handleConfirm,
  };
});
